import { useEffect, useRef } from "react";
import { isAuthEnabled } from "../../config/environment";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { getProblemById } from "../../models/problems";
import { leaveProblem } from "../../store/game/gameSlice";
import { useAuth } from "./AuthProvider";

/**
 * A signed-out player who lands on the canvas mid-problem (an attempt from before accounts, or
 * an expired session) is asked to sign in. Closing the dialog leaves the problem; the canvas
 * stays as a scratchpad and the attempt stays saved for later.
 */
export const ActiveProblemAuthGate: React.FC = () => {
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) => state.auth.status);
  const activeProblemId = useAppSelector((state) => state.game.activeProblemId);
  const { openAuthDialog } = useAuth();
  const promptedRef = useRef(false);

  useEffect(() => {
    if (promptedRef.current || status !== "signedOut" || !isAuthEnabled()) return;
    const problem = getProblemById(activeProblemId);
    if (!problem) return;
    promptedRef.current = true;
    openAuthDialog({
      reason: "resume",
      problemTitle: problem.title,
      pendingProblem: { problemId: problem.id, restart: false },
      onCancel: () => dispatch(leaveProblem()),
    });
  }, [status, activeProblemId, openAuthDialog, dispatch]);

  return null;
};
